var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXumm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.98881 12.0094L10.2626 14.2867C10.7542 14.7747 11 15.1949 11 15.5473C11 15.8862 10.7542 16.2996 10.2626 16.7876C9.77096 17.262 9.35442 17.4993 9.01305 17.4993C8.67164 17.4993 8.2551 17.2553 7.7635 16.7673L5.51026 14.5103L3.2365 16.7673C2.74488 17.2553 2.32837 17.4993 1.98697 17.4993C1.65922 17.4993 1.24271 17.262 0.737431 16.7876C0.24581 16.2996 0 15.8862 0 15.5473C0 15.1949 0.24581 14.7747 0.737431 14.2867L3.01117 12.0094L0.737431 9.73217C0.24581 9.24418 0 8.83075 0 8.49187C0 8.13944 0.24581 7.71923 0.737431 7.23125C1.24271 6.74326 1.65922 6.49927 1.98697 6.49927C2.32837 6.49927 2.74488 6.74326 3.2365 7.23125L5.51026 9.50851L7.7635 7.23125C8.2551 6.74326 8.67164 6.49927 9.01305 6.49927C9.35442 6.49927 9.77096 6.74326 10.2626 7.23125C10.7542 7.71923 11 8.13944 11 8.49187C11 8.83075 10.7542 9.24418 10.2626 9.73217L7.98881 12.0094Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4543 6.99836C24.1353 7.71165 24.1858 8.92633 23.5672 9.71144L17.9268 16.8702C17.6158 17.265 17.1762 17.4929 16.7135 17.4991C16.2509 17.5054 15.8069 17.2896 15.488 16.9032L12.4594 13.2365C11.8251 12.4684 11.8508 11.2527 12.5169 10.5212C13.183 9.78962 14.2373 9.81927 14.8716 10.5874L16.6652 12.759L21.1014 7.12839C21.72 6.34329 22.7734 6.28508 23.4543 6.99836Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXumm);
export default __webpack_public_path__ + "static/media/xumm.817580b436dfe6659abcec59311f87c4.svg";
export { ForwardRef as ReactComponent };